import React, { useState, useEffect,  useContext  } from "react";
import AuthContext from "../../../../../contexts/auth";
import { useForm } from "react-hook-form";
import Spinner from "../../../../../components/Spinner";
import NotifyC from "../../../../../components/Notifications";
import { useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FaCheckCircle, FaArrowLeft } from "react-icons/fa";
import { RiHomeOfficeFill } from "react-icons/ri";
import * as FaIcons from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { useOffice } from '../../../../../hooks/useOffice';
import { useCash } from '../../../../../hooks/useCash';
import { useClient} from '../../../../../hooks/useClient';
import Swal from "sweetalert2";
import SelectSearch from "../../../../../components/ui/SelectSearch";
import SelectMultiSearch from "../../../../../components/ui/SelectMultiSearch";
import "./HorizontalStepper.css";
import { normalizeIdNumber, validateIdFormat, idFormats, provincesPrefix, updateFullId } from "../../../../../utils/Common";

const HorizontalStepper = () => {
    const { register, reset, watch, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            nombre: '',
            apellido: '',
            email: '',
            usuario: '',
            RoleBli: '',
            idEstatus: 1,
            Sucursal: '',
            Caja: ''
        }
    });

    const { getClientRoles } = useClient();
    const { createClient } = useContext(AuthContext);
    const { getPostOfficesList, getListProvinces } = useOffice();
    const { getCashBoxesList  } = useCash();
    const [isLoading, setIsLoading] = useState(false);
    const [officeList, setOfficeList] = useState([]);
    const [provinceList, setProvinceList] = useState([]);
    const [cashList, setCashList] = useState([]);
    const [officeSelected, setOfficeSelected] = useState(null);
    const [provinceSelected, setProvinceSelected] = useState(null);
    const [multiOfficesSelected, setMultiOfficesSelected] = useState([]);
    const [roleSelected, setRoleSelected] = useState(null);
    const [cajaSelected, setCajaSelected] = useState(null);
    const [roles, setRoles] = useState([]);
    const [idType, setIdType] = useState("cedula"); 
    const [controlStep, setControlStep] = useState({
        nombreStep: false,
        apellidoStep: false,
        NumIdStep: false,
        emailStep: false,
        usuarioStep: false,
        idRoleBliStep: false,
        idSucursalStep: false,
        idCajaStep: false,
        submitBtn: false,
    });
    const [idPrefix, setIdPrefix] = useState(null);
    const idOptions = idFormats();
    const idProvinces = provincesPrefix();

    const handleGetOfficeForClient = async (provinceSelected) => {
        const abortController = new AbortController();
        try {
          const dataToSend = { IdCliente: 0, IdProvincia: provinceSelected };
          const response = await getPostOfficesList(abortController.signal, dataToSend);
          if (response.length > 0) {
            setOfficeList(response);
          } else {
            setOfficeList([]);
            NotifyC.error('No se encontraron estafetas por asignar para usuario');
          }
        } catch (error) {
          NotifyC.error('Error al obtener la lista de estafetas');
        }
      };

    const handleGetOfficeByProvince = async () => {
        const abortController = new AbortController();
        try {
            const response = await getListProvinces(abortController.signal);
            if (response.length > 0) {
                setProvinceList(response);
            } else {
                setProvinceList([]);
                NotifyC.error('No se encontraron estafetas por asignar en la provincia seleccionada al usuario');
            }
        } catch (error) {
            NotifyC.error('Error al obtener la lista de provincias');
        }
    };

    const handleGetCashBoxesList = async (officeId) => {
        setCashList([]);
        const abortController = new AbortController();
        try {
          const dataToSend = { IdCliente: 0, IdEstafeta: officeId };
          const response = await getCashBoxesList(abortController.signal, dataToSend);
          if (response.length > 0) {
          setCashList(response);
          }else {
            setCashList([]);
            NotifyC.error('No se encontraron cajas por asignar para usuario');
          }
        } catch (error) {
          NotifyC.error('Error al obtener la lista de cajas');
        }
      };

      const handleGetRoles = async () => {
        const abortController = new AbortController();
        try {
          const response = await getClientRoles(abortController.signal);
          if (response.length > 0) {
            const responseFiltered = response.filter((item) => item.value !== 0 && item.value !== 9);
            setRoles(responseFiltered);
          } else {
            NotifyC.error('No se encontraron roles para asignar a usuarios');
          }
        } catch (error) {
          NotifyC.error('Error al obtener roles');
        }
      }

    useEffect(() => {
        handleGetOfficeByProvince();
    if (provinceSelected) {
        handleGetOfficeForClient(provinceSelected);
    } else {
        setOfficeList([]);
    }
        handleGetRoles();
    }, [provinceSelected]);



    useEffect(() => {
        if (officeSelected) {
            handleGetCashBoxesList(officeSelected);
        }
    }, [officeSelected]);

    const onSubmit = async (data) => {

        const idNumber = updateFullId(idPrefix, data.NumDocumento, idType);

        if (validateIdFormat(idNumber, idType) === false) {
            NotifyC.error("El número de identificación no es válido.", {duration: 4000,});
            return;
        }

        const confirm = await Swal.fire({
            icon: "warning",
            title: "¿Estás seguro de crear el usuario?",
            showCancelButton: true,
            confirmButtonText: "Sí",
            cancelButtonText: "No",
            customClass: {
                confirmButton: 'custom-confirm-button',
                cancelButton: 'custom-cancel-button',
            },
        });

        if (!confirm.isConfirmed) return;

        const abortController = new AbortController();
        try {
            setIsLoading(true);

            const skipSucursalCaja = [7, 8, 9].includes(roleSelected);

            const dataToSend = {
                Nombre: data.nombre,
                Apellido: data.apellido,
                tipoDocumento: idType ?? null,
                numDocumento: idNumber,
                Email: data.email,
                Usuario: data.usuario,
                IdRoleBli: roleSelected,
                IdEstatus: 1,
                ...(skipSucursalCaja ? {} : {
                    IdSucursal: officeSelected ?? null,
                    IdCaja: cajaSelected ?? null,
                    IdProvincia: multiOfficesSelected.length > 0 ? multiOfficesSelected : null,
                }),
            };

            const response = await createClient(abortController.signal, dataToSend);

            if (response?.code === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Usuario creado",
                    html: `El usuario ha sido creado exitosamente`,
                    confirmButtonText: "Ok",
                    customClass: {
                        confirmButton: 'custom-confirm-button',
                    },
                });

                resetForm();
            } else {
                if (response?.code === 400) {
                    switch (response.message) {
                        case "USER_OR_EMAIL_ALREADY_EXIST":
                            NotifyC.error("El usuario o email ya existen, intentalo de nuevo");
                            break;
                        case 'OFFICE_NOT_FOUND':
                            NotifyC.error("La estafeta no existe, intentalo de nuevo");
                            break;
                        case 'CASHBOX_NOT_FOUND':
                            NotifyC.error("La caja no existe, intentalo de nuevo");
                            break;
                        case 'CASHBOX_NOT_IN_OFFICE':
                            NotifyC.error("La caja no pertenece a la estafeta seleccionada, intentalo de nuevo");
                            break;
                        default:
                            NotifyC.error("Ha ocurrido un error inesperado, intentalo de nuevo");
                            break;
                    }
                }
            }
            setIsLoading(false);
        } catch {
            setIsLoading(false);
            Swal.fire({
                icon: "error",
                title: "Error al crear el usuario",
                text: "Ha ocurrido un error inesperado, intentalo de nuevo",
                confirmButtonText: "Ok",
                customClass: {
                    confirmButton: 'custom-confirm-button',
                },
            });
        }
    };

    const resetForm = () => {
        reset();
        setControlStep({
            nombreStep: false,
            apellidoStep: false,
            NumIdStep: false,
            emailStep: false,
            usuarioStep: false,
            idRoleBliStep: false,
            idSucursalStep: false,
            idCajaStep: false,
            submitBtn: false,
        });
        setRoleSelected(null);
        setOfficeSelected(null);
        setCajaSelected(null);
        setProvinceSelected(null);
        setMultiOfficesSelected([]);
    };
    
    const validateSteps = () => {
        const nombre = !!(watch("nombre")?.trim() || "");
        const apellido = !!(watch("nombre")?.trim() && watch("apellido")?.trim());
        const numId = !!(watch("nombre")?.trim() && watch("apellido")?.trim() && watch("NumDocumento")?.trim());
        const email = !!(watch("nombre")?.trim() && watch("apellido")?.trim() && watch("NumDocumento")?.trim() && watch("email")?.trim());
        const usuario = !!(watch("nombre")?.trim() && watch("apellido")?.trim() && watch("NumDocumento")?.trim() && watch("email")?.trim() && watch("usuario")?.trim());
        const role = roleSelected !== null;

        // Si el rol es 7, 8 u 9, no se requiere sucursal ni caja
        const skipSucursalCaja = [7, 8, 9].includes(roleSelected);

        setControlStep({
            nombreStep: nombre,
            apellidoStep: apellido,
            NumIdStep: numId,
            emailStep: email,
            usuarioStep: usuario,
            idRoleBliStep: usuario && role,
            idSucursalStep: skipSucursalCaja ? true : (usuario && role && (officeSelected !== null || multiOfficesSelected.length >= 1)),
            idCajaStep: skipSucursalCaja ? true : (usuario && role && officeSelected !== null && cajaSelected !== null),
            submitBtn: usuario && role && (
                skipSucursalCaja ||
                (officeSelected !== null || multiOfficesSelected.length > 0)
            ),
        });
    };

    const renderInput = (field, label, required, type, placeholder, mask, setIdType, idType) => {
        return (<> 
        <div className="form-group text-left">
            { !mask ? (<> 
              <label>
                {label} {required && <span className="text-danger">*</span>}
             </label>
            <input
                type={type ?? "text"}
                className="form-control"
                name={field}
                ref={register({
                    required: required ? "Este campo es obligatorio" : false
                })}
                onChange={() => validateSteps(field)}
                placeholder={placeholder
                    ? placeholder
                    : `Ingrese ${label.toLowerCase()}`
                }
                />
            </>) : (<>
                <div className="form-group">
                    <label>
                    Número de Identificación
                    <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                        <div className="input-group-append">
                        <SelectSearch
                        options={idOptions}
                        nameInput="idType"
                        setValue={(_, value) => setIdType(value)}
                        value={idType}
                        isRequired
                        className="form-control"
                        style={{ width: "auto" }}
                        />
                    </div>  
                    {["cedula-E", "cedula-N"].includes(idType) ? (
                <>
                  <div className="ml-2">
                    <input
                      type="text"
                      className="form-control combo-input prefix-display-input"
                      value={`${idType.split("-")[1]}-`}
                      readOnly
                      aria-label="Tipo de cédula"
                    />
                  </div>
                  <div className="input-group-append">
                    <div className="input-group-append">
                      <SelectSearch
                        options={idProvinces}
                        nameInput="Prefix"
                        setValue={(_, value) => setIdPrefix(value)}
                        value={idPrefix}
                        isRequired
                        className="form-control"
                        style={{ width: "auto" }}
                      />
                    </div>
                  </div>
                  <span className="input-group-text">-</span>
                </>
              ) : idType === "cedula-PE" ? (
                <>
                  <div className="ml-2">
                    <input
                      type="text"
                      className="form-control combo-input prefix-display-input"
                      value="PE-"
                      readOnly
                      aria-label="Tipo de cédula"
                    />
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Prefijo"
                    value={idPrefix || ""}
                    onChange={(e) => setIdPrefix(e.target.value)}
                    style={{ maxWidth: "80px" }}
                  />
                  <span className="input-group-text">-</span>
                </>
              ) : ["cedula", "cedula-AV", "cedula-PI"].includes(idType) ? ( <> 
                <div className="ml-2">
                  <SelectSearch
                    options={idProvinces}
                    nameInput="Prefix"
                    setValue={(_, value) => setIdPrefix(value)}
                    value={idPrefix}
                    isRequired
                    className="form-control"
                    style={{ width: "auto" }}
                  />
                   
                </div>
                {["cedula"].includes(idType) &&( 
                  <span className="input-group-text">-</span>
                 )}
           
              </>) : null}
                    <input
                        type="text"
                        placeholder={idOptions.find((option) => option.value === idType)?.placeholder ?? ""}
                        className="form-control"
                        name={field}
                        ref={register({
                            required: required ? "Este campo es obligatorio" : false,
                        })}
                        onChange={(event) => {
                            const { value } = event.target;
                            event.target.value = normalizeIdNumber(value, idType);
                            validateSteps();
                        }}
                        />
                    </div>
                </div>
            </>)}
            {errors[field] && (
                <span className="text-danger">{errors[field].message}</span>
            )}
        </div>
        </>);
    };

        const handleSelect = (name, value) => {
        if (name === "RoleBli") {
            setRoleSelected(value);
            setValue("RoleBli", value); 
            setOfficeSelected(null);
            setProvinceSelected(null);
            setMultiOfficesSelected([]);
        }
        if (name === "Provincia") {
            setProvinceSelected(value);
            setOfficeSelected(null);
            setOfficeList([]);
        }
        if (name === "Provincias") {
            setMultiOfficesSelected(value);
        }
        if (name === "Sucursal") {
            setOfficeSelected(value);
            setValue("Sucursal", value);
            setCajaSelected(null); 
            setValue("Caja", null); 
        }
        if (name === "Caja") {
            setCajaSelected(value);
            setValue("Caja", value); 
        }
        validateSteps(); 
    };

    const steps = [
        {
            label: "Nombre",
            icon: <FaIcons.FaAddressCard size={20} color="black" />,
            bgIcon: "#fbd825",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("nombre", "Nombre", true, "text", "Nombre del usuario")}
                </div>
            ),
        },
        {
            label: "Apellido",
            icon: <FaIcons.FaAddressCard size={20} />,
            bgIcon: "#e2131b",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("apellido", "Apellido", true, "text", "Apellido del usuario")}
                </div>
            ),
        },
        {
            label: "Número de identificación",
            icon: <FaIcons.FaIdCard size={20} />,
            bgIcon: "#0c4271",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("NumDocumento", "Tipo de identificación", true, "text", "Tipo de identificación", true, setIdType, idType)}
                </div>
            ),
        },
        {
            label: "Email",
            icon: <IoMdMail size={20} />,
            bgIcon: "#0c4271",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("email", "Email", true, "email", "Email del usuario")}
                </div>
            ),
        },
        {
            label: "Usuario",
            icon: <FaIcons.FaUserClock size={20} />,
            bgIcon: "#0c4271",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("usuario", "Usuario", true, "text", "Usuario del usuario")}
                </div>
            ),
        },
        {
            label: "Rol de usuario",
            icon: <RiHomeOfficeFill size={20} />,
            bgIcon: "#0c4271",
            content: (
                <div className="horizontal-stepper">
                    <div className="form-group text-left">
                        <label>
                            Rol de usuario 
                            <span className="text-danger">*</span>
                        </label>
                        <SelectSearch
                        options={roles}
                        nameInput={"RoleBli"}
                        setValue={handleSelect}
                        value={roleSelected}
                        placeholder="Seleccione un rol"
                    />
                    </div>
                </div>
                ),
        },
        // Solo mostrar sucursal/caja si el rol NO es 7, 8 u 9
        ...([7, 8, 9].includes(roleSelected) ? [] : [
            {
                label: [4,5,6].includes(roleSelected) ? "Provincia" : "Estafeta",
                icon: <RiHomeOfficeFill size={20} />,
                bgIcon: "#0c4271",
                content: (
                    <div className="horizontal-stepper">
                        <div className="form-group text-left">
                         {[4,5,6].includes(roleSelected)  ? ( <>
                            <label>
                                Provincia
                                <span className="text-danger">*</span>
                            </label>
                           
                                <SelectMultiSearch
                                    options={provinceList}
                                    nameInput={"Provincias"}
                                    setValue={handleSelect}
                                    value={multiOfficesSelected}
                                    placeholder="Seleccionar"
                                />
                           </> ) : (<> 
                              <label>
                                Estafeta
                                <span className="text-danger">*</span>
                            </label>
                            <div className="d-flex flex-row">
                            <div className="input-group-append">
                                <SelectSearch
                                    options={provinceList}
                                    nameInput={"Provincia"}
                                    setValue={handleSelect}
                                    value={provinceSelected}
                                    placeholder="Seleccionar provincia"
                                />
                            </div>
                                <SelectSearch
                                    options={officeList}
                                    nameInput={"Sucursal"}
                                    setValue={handleSelect}
                                    value={officeSelected}
                                    placeholder="Seleccionar estafeta"
                                />
                            </div>
                        </> )}
                        </div>
                    </div>
                ),
            },
            ...[2,4,5,6,7,8].includes(roleSelected) ? [] : [
            {
                label: "Caja",
                icon: <FaIcons.FaCashRegister size={20} />,
                bgIcon: "#0c4271",
                content: (
                    <div className="horizontal-stepper">
                        <div className="form-group text-left">
                            <label>
                                Caja
                                <span className="text-danger">*</span>
                            </label>
                        <SelectSearch
                            options={cashList}
                            nameInput={"Caja"}
                            setValue={handleSelect}
                            value={cajaSelected}
                            placeholder="Seleccione una caja"
                        />
                        </div>
                    </div>
                ),
            },
            ]
        ])
    ];

    useEffect(() => {
        validateSteps();
    }, [watch("nombre"), watch("apellido"), watch("email"), watch("usuario"), roleSelected, officeSelected, cajaSelected, multiOfficesSelected]);

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "30px",
                }}
            >
                <div
                    style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        background: `#0c4271`,
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "10px",
                    }}
                >
                    <FaIcons.FaUser size={20} />
                </div>
                <span style={{ fontSize: "18px", fontWeight: "500" }}>
                    Información del usuario
                </span>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className="col-12 col-md-3"
                            style={{ marginBottom: "20px", borderBottom: "1px dashed #e3e3e3" }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: `${step.bgIcon}`,
                                        color: step.colorIcon ?? "white",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginRight: "10px",
                                        
                                    }}
                                >
                                    {step.icon}
                                </div>
                                <span style={{ fontSize: "18px", fontWeight: "500" }}>
                                    {step.label}
                                </span>
                            </div>
                            <CSSTransition
                                    in={
                                        index === 0 ||
                                        (index === 1 && controlStep.nombreStep) ||
                                        (index === 2 && controlStep.nombreStep && controlStep.apellidoStep) ||
                                        (index === 3 && controlStep.nombreStep && controlStep.apellidoStep && controlStep.NumIdStep) ||
                                        (index === 4 && controlStep.nombreStep && controlStep.apellidoStep && controlStep.NumIdStep && controlStep.emailStep) ||
                                        (index === 5 && controlStep.nombreStep && controlStep.apellidoStep && controlStep.NumIdStep && controlStep.emailStep && controlStep.usuarioStep) ||
                                        (index === 6 && controlStep.nombreStep && controlStep.apellidoStep && controlStep.NumIdStep && controlStep.emailStep && controlStep.usuarioStep && controlStep.idRoleBliStep) ||
                                        (index === 7 && controlStep.nombreStep && controlStep.apellidoStep && controlStep.NumIdStep && controlStep.emailStep && controlStep.usuarioStep && controlStep.idRoleBliStep && controlStep.idSucursalStep) 
                                    }
                                    timeout={200}
                                    classNames="step"
                                    unmountOnExit
                                >
                                    <div className="px-1">{step.content}</div>
                                </CSSTransition>
                        </div>
                    ))}
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: "10px",
                        marginTop: "20px",
                    }}
                >
                    <button
                        type="submit"
                        className="btn btn-blue"
                        disabled={!controlStep.submitBtn || isLoading}
                    >
                        {isLoading ? <Spinner type={1} /> : <><FaCheckCircle /> Crear usuario</>}
                    </button>
                </div>
            </form>
        </>
    );
};

const CreateClient = () => {
    const history = useHistory();
    return (
        <>
            <div className="dashboardCard text-left" style={{ color: "black" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
                    <div className="d-flex align-items-center" style={{ gap: "15px", flex: "1" }}>
                        <FaIcons.FaUser size={20} className="mr-1" />
                        <h5 className="mb-0">Crear Usuario</h5>
                    </div>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => history.push("/dashboard/administration/users")}
                    >
                        <FaArrowLeft /> Regresar
                    </button>
                </div>
            </div>
            <div className="dashboardCard">
                <HorizontalStepper />
            </div>
        </>
    );
};

export default CreateClient;